import { Component, EventEmitter, OnChanges, Input, Output } from '@angular/core';

import { MonitoringFilterItem } from '@classes/monitoring/monitoring-filter-item';

@Component({
  selector: 'app-monitoring-filters-select-multi',
  templateUrl: './monitoring-filters-select-multi.component.html',
  styleUrls: ['./monitoring-filters-select-multi.component.scss']
})
export class MonitoringFiltersSelectMultiComponent implements OnChanges {

    @Input() title: string;
    @Input() allLabel = "All";

    @Input() @Output() items: MonitoringFilterItem[] = [];

    @Output() selectionChange = new EventEmitter<MonitoringFilterItem[]>();

    selection: string[] = [];
    selectionLabel: string;
    visibleItems: MonitoringFilterItem[] = [];

    constructor () {}

    ngOnChanges () { this.updateItems(); }

    onSelectAll () {
        const isSelected = this.visibleItems.some(i => !i.isSelected);
        this.visibleItems.forEach(i => i.isSelected = isSelected);
        this.updateSelection();
        this.emitSelection  ();
    }
    onSelectionChange (selection: string[]) {
        const item = this.visibleItems
            .find(f => f.isSelected !== selection.some(s => s === f.code));
        if (!item) { return; }

        item.isSelected = !item.isSelected;
        this.selection  = selection       ;

        this.updateSelection();
        this.emitSelection  ();
    }

    private updateItems () {
        this.visibleItems = this.items ?? [];
        this.visibleItems = this.visibleItems.sort(this.compareItems);
        this.updateSelection();
    }
    private updateSelection () {
        this.selection = this.visibleItems.filter(i => i.isSelected).map(i => i.code);
        if (this.isAllSelected()) { this.selection.push(''); }

        this.selectionLabel = this.getSelectionLabel();
    }

    private emitSelection () {
        this.selectionChange.emit(this.visibleItems);
    }

    private isAllSelected (): boolean {
        return !this.visibleItems.some(i => !i.isSelected);
    }
    private getSelectionLabel (): string {
        const selection = this.visibleItems.filter(i => i.isSelected);

        if (selection.length === 0) { return ""                ; }
        if (selection.length === 1) { return selection[0].label; }
        if (this.isAllSelected()  ) { return this.allLabel     ; }

        return selection.map(i => i.label).join('; ');
    }

    private compareItems (a: MonitoringFilterItem, b: MonitoringFilterItem) {
        if (a.label < b.label) { return -1; }
        if (a.label > b.label) { return +1; }
        return 0;
    }

}
